export async function encrypt(word: string): Promise<string> {
  const password = "3sc3RLrpd17";

  const encoder = new TextEncoder();
  const passwordData = encoder.encode(password);
  const keyMaterial = await crypto.subtle.digest("SHA-256", passwordData);

  const iv = new Uint8Array(16);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyMaterial,
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );

  const plaintext = encoder.encode(word);
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    plaintext
  );

  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
